import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0403 = React.lazy(() => import('./symbols/0403_money_usa_dollar'));
const Symbol0404 = React.lazy(() => import('./symbols/0404_money_europe_euro'));
const Symbol0405 = React.lazy(() => import('./symbols/0405_money_bag_dollar'));
const Symbol0406 = React.lazy(
  () => import('./symbols/0406_money_dollar_euro_currency_exchange_cash')
);
const Symbol0407 = React.lazy(() => import('./symbols/0407_credit_card'));
const Symbol0408 = React.lazy(() => import('./symbols/0408_wallet_money_payment'));
const Symbol0409 = React.lazy(() => import('./symbols/0409_wallet_credit_card_money_payment'));
const Symbol0410 = React.lazy(() => import('./symbols/0410_cash_register_payment'));
const Symbol0411 = React.lazy(() => import('./symbols/0411_invoice_dollar_bill_payment'));
const Symbol0412 = React.lazy(() => import('./symbols/0412_free'));
const Symbol0413 = React.lazy(() => import('./symbols/0413_money_coins_jettons_chips'));
const Symbol0414 = React.lazy(() => import('./symbols/0414_money_cash_coins_payment'));
const Symbol0415 = React.lazy(() => import('./symbols/0415_saving_sale_discount_piggy_bank_pig'));
const Symbol0416 = React.lazy(() => import('./symbols/0416_calculator'));
const Symbol0417 = React.lazy(() => import('./symbols/0417_calculator'));
const Symbol0418 = React.lazy(() => import('./symbols/0418_bank_pantheon'));
const Symbol0419 = React.lazy(() => import('./symbols/0419_payment_mobile_nfc_apple_pay_cashless'));
const Symbol0420 = React.lazy(() => import('./symbols/0420_money_cash_coins_payment_dollars'));
const Symbol0421 = React.lazy(() => import('./symbols/0421_money_credit_card_coins_payment'));
const Symbol0422 = React.lazy(() => import('./symbols/0422_no_cash_payment_cashless'));
const Symbol0423 = React.lazy(() => import('./symbols/0423_coin_payment_chip'));
const Symbol0424 = React.lazy(() => import('./symbols/0424_money_payment_dollar_cash'));
const Symbol0425 = React.lazy(() => import('./symbols/0425_money_payment_dollar_cash'));
const Symbol0426 = React.lazy(() => import('./symbols/0426_money_payment_dollars_coins_cash'));
const Symbol0427 = React.lazy(() => import('./symbols/0427_money_payment_dollar_coins_chips'));
const Symbol0428 = React.lazy(() => import('./symbols/0428_money_payment_dollar_bag_cash'));
const Symbol0429 = React.lazy(() => import('./symbols/0429_money_payment_euro_bag_cash'));
const Symbol0430 = React.lazy(() => import('./symbols/0430_money_payment_dollar_coins_cash'));
const Symbol0431 = React.lazy(() => import('./symbols/0431_money_atm_machine_withdrawal_cash'));
const Symbol0432 = React.lazy(() => import('./symbols/0432_atm_machine_withdrawal_credit_card'));
const Symbol0433 = React.lazy(() => import('./symbols/0433_money_currency_exchange'));
const Symbol0434 = React.lazy(() => import('./symbols/0434_gold_reserve'));
const Symbol0435 = React.lazy(() => import('./symbols/0435_bitcoin_money'));
const Symbol0436 = React.lazy(() => import('./symbols/0436_bitcoin_wallet_payment'));
const Symbol0436a = React.lazy(() => import('./symbols/0436a_pound_britain_currency_money'));
const Symbol0436b = React.lazy(() => import('./symbols/0436b_pound_britain_currency_money'));

export interface IProps {}

const Finance: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0403_money_usa_dollar" symbol={<Symbol0403 />} />
      <LazySymbol id="0404_money_europe_euro" symbol={<Symbol0404 />} />
      <LazySymbol id="0405_money_bag_dollar" symbol={<Symbol0405 />} />
      <LazySymbol id="0406_money_dollar_euro_currency_exchange_cash" symbol={<Symbol0406 />} />
      <LazySymbol id="0407_credit_card" symbol={<Symbol0407 />} />
      <LazySymbol id="0408_wallet_money_payment" symbol={<Symbol0408 />} />
      <LazySymbol id="0409_wallet_credit_card_money_payment" symbol={<Symbol0409 />} />
      <LazySymbol id="0410_cash_register_payment" symbol={<Symbol0410 />} />
      <LazySymbol id="0411_invoice_dollar_bill_payment" symbol={<Symbol0411 />} />
      <LazySymbol id="0412_free" symbol={<Symbol0412 />} />
      <LazySymbol id="0413_money_coins_jettons_chips" symbol={<Symbol0413 />} />
      <LazySymbol id="0414_money_cash_coins_payment" symbol={<Symbol0414 />} />
      <LazySymbol id="0415_saving_sale_discount_piggy_bank_pig" symbol={<Symbol0415 />} />
      <LazySymbol id="0416_calculator" symbol={<Symbol0416 />} />
      <LazySymbol id="0417_calculator" symbol={<Symbol0417 />} />
      <LazySymbol id="0418_bank_pantheon" symbol={<Symbol0418 />} />
      <LazySymbol id="0419_payment_mobile_nfc_apple_pay_cashless" symbol={<Symbol0419 />} />
      <LazySymbol id="0420_money_cash_coins_payment_dollars" symbol={<Symbol0420 />} />
      <LazySymbol id="0421_money_credit_card_coins_payment" symbol={<Symbol0421 />} />
      <LazySymbol id="0422_no_cash_payment_cashless" symbol={<Symbol0422 />} />
      <LazySymbol id="0423_coin_payment_chip" symbol={<Symbol0423 />} />
      <LazySymbol id="0424_money_payment_dollar_cash" symbol={<Symbol0424 />} />
      <LazySymbol id="0425_money_payment_dollar_cash" symbol={<Symbol0425 />} />
      <LazySymbol id="0426_money_payment_dollars_coins_cash" symbol={<Symbol0426 />} />
      <LazySymbol id="0427_money_payment_dollar_coins_chips" symbol={<Symbol0427 />} />
      <LazySymbol id="0428_money_payment_dollar_bag_cash" symbol={<Symbol0428 />} />
      <LazySymbol id="0429_money_payment_euro_bag_cash" symbol={<Symbol0429 />} />
      <LazySymbol id="0430_money_payment_dollar_coins_cash" symbol={<Symbol0430 />} />
      <LazySymbol id="0431_money_atm_machine_withdrawal_cash" symbol={<Symbol0431 />} />
      <LazySymbol id="0432_atm_machine_withdrawal_credit_card" symbol={<Symbol0432 />} />
      <LazySymbol id="0433_money_currency_exchange" symbol={<Symbol0433 />} />
      <LazySymbol id="0434_gold_reserve" symbol={<Symbol0434 />} />
      <LazySymbol id="0435_bitcoin_money" symbol={<Symbol0435 />} />
      <LazySymbol id="0436_bitcoin_wallet_payment" symbol={<Symbol0436a />} />
      <LazySymbol id="0436a_pound_britain_currency_money" symbol={<Symbol0436b />} />
      <LazySymbol id="0436b_pound_britain_currency_money" symbol={<Symbol0436 />} />
    </>
  );
});

Finance.displayName = 'Finance';

export default Finance;
